/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Shift } from './Shift';
import {
    ShiftFromJSON,
    ShiftFromJSONTyped,
    ShiftToJSON,
    ShiftToJSONTyped,
} from './Shift';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface ScheduleOverviewSummary
 */
export interface ScheduleOverviewSummary {
    /**
     * A deterministic identifier for the report.
     * @type {string}
     * @memberof ScheduleOverviewSummary
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduleOverviewSummary
     */
    companyId: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof ScheduleOverviewSummary
     */
    startDate: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof ScheduleOverviewSummary
     */
    endDate: ShiftiePlainDate;
    /**
     * Which schedule this summary applies to. When null, it applies to all schedules.
     * @type {number}
     * @memberof ScheduleOverviewSummary
     */
    scheduleId: number;
    /**
     * Unclaimed open shifts within the date range.
     * @type {Array<Shift>}
     * @memberof ScheduleOverviewSummary
     */
    unclaimedOpenShifts: Array<Shift>;
    /**
     * Unconfirmed shifts within the date range.
     * @type {Array<Shift>}
     * @memberof ScheduleOverviewSummary
     */
    unconfirmedShifts: Array<Shift>;
    /**
     * Unpublished assigned shifts and unpublished open shifts within the date range.
     * @type {Array<Shift>}
     * @memberof ScheduleOverviewSummary
     */
    unpublishedShifts: Array<Shift>;
    /**
     * Shifts which are in conflict, e.g. with an existing leave request or unavailability.
     * @type {Array<Shift>}
     * @memberof ScheduleOverviewSummary
     */
    conflictingShifts: Array<Shift>;
}

/**
 * Check if a given object implements the ScheduleOverviewSummary interface.
 */
export function instanceOfScheduleOverviewSummary(value: object): value is ScheduleOverviewSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('scheduleId' in value) || value['scheduleId'] === undefined) return false;
    if (!('unclaimedOpenShifts' in value) || value['unclaimedOpenShifts'] === undefined) return false;
    if (!('unconfirmedShifts' in value) || value['unconfirmedShifts'] === undefined) return false;
    if (!('unpublishedShifts' in value) || value['unpublishedShifts'] === undefined) return false;
    if (!('conflictingShifts' in value) || value['conflictingShifts'] === undefined) return false;
    return true;
}

export function ScheduleOverviewSummaryFromJSON(json: any): ScheduleOverviewSummary {
    return ScheduleOverviewSummaryFromJSONTyped(json, false);
}

export function ScheduleOverviewSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleOverviewSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'startDate': ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': ShiftiePlainDateFromJSON(json['endDate']),
        'scheduleId': json['scheduleId'],
        'unclaimedOpenShifts': ((json['unclaimedOpenShifts'] as Array<any>).map(ShiftFromJSON)),
        'unconfirmedShifts': ((json['unconfirmedShifts'] as Array<any>).map(ShiftFromJSON)),
        'unpublishedShifts': ((json['unpublishedShifts'] as Array<any>).map(ShiftFromJSON)),
        'conflictingShifts': ((json['conflictingShifts'] as Array<any>).map(ShiftFromJSON)),
    };
}

  export function ScheduleOverviewSummaryToJSON(json: any): ScheduleOverviewSummary {
      return ScheduleOverviewSummaryToJSONTyped(json, false);
  }

  export function ScheduleOverviewSummaryToJSONTyped(value?: ScheduleOverviewSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'scheduleId': value['scheduleId'],
        'unclaimedOpenShifts': ((value['unclaimedOpenShifts'] as Array<any>).map(ShiftToJSON)),
        'unconfirmedShifts': ((value['unconfirmedShifts'] as Array<any>).map(ShiftToJSON)),
        'unpublishedShifts': ((value['unpublishedShifts'] as Array<any>).map(ShiftToJSON)),
        'conflictingShifts': ((value['conflictingShifts'] as Array<any>).map(ShiftToJSON)),
    };
}

